import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosAddEditProductReturnManualModalComponent } from './pos-add-edit-product-return-manual-modal.component';
import { PosAddEditProductReturnManualModalService } from 'src/app/@core/services/pos-add-edit-product-return-manual-modal.service';
import { ReactiveFormsModule } from '@angular/forms';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';
import { PosProductsModalModule } from '../pos-products-modal/pos-products-modal.module';



@NgModule({
  declarations: [
    PosAddEditProductReturnManualModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RequiredAsteriskModule,
    PosProductsModalModule
  ],
  providers: [PosAddEditProductReturnManualModalService],
  exports: [PosAddEditProductReturnManualModalComponent]
})
export class PosAddEditProductReturnManualModalModule { }
